module.exports = __webpack_public_path__ + "img/20240428-144015.b3d3354f.png";